exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header{background-color:#fafafa;display:flex;justify-content:space-between;height:60px;width:100%;padding:0 calc(50% - 480px);overflow:hidden;position:fixed;top:0;left:0;z-index:99}header .enca-nav-element{max-height:60px}.enca-nav-element{border-bottom:6px solid #333;color:#383838;cursor:pointer;display:inline-block;padding:16px 20px}.enca-nav-element i,.enca-nav-element img,.enca-nav-element span{vertical-align:middle}.enca-nav-element span{font-weight:500;text-transform:uppercase;margin-left:8px}.enca-nav-element:hover{background-color:rgba(0,0,0,.1)}.enca-nav-element.orange{border-bottom-color:#ea6011}.enca-nav-element.blue{border-bottom-color:#0f2ab7}.enca-nav-element.green{border-bottom-color:#1baf34}.enca-nav-element.purple{border-bottom-color:#7a0fc2}@media (max-width:640px){.enca-nav-element span{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-534f3e8c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Header.vue
// module id = 29
// module chunks = 0